/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
import Router from 'next/router';
import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import qs from 'query-string';
import daysjs from 'dayjs';
import jsCookie from "js-cookie";
import actions, { actionTypes } from '../../../shell/actions';
import { NextServerAPI, tomiAI } from '../../../utils';
import { AGENT_CONSTANTS } from 'client/modules/agents/constants/agent.constants';

const QUOTATION_SERVICE_UNAVAILABLE = 'Layanan quotation sudah tidak tersedia.';

function getFilterForList(type, searchQuery) {
  let filterObject = {};

  switch (type) {
    case 'INCOMPLETE':
      filterObject = {
        statuses: ['ACTIVE', 'PENDING_QA', 'REVISE'],
        stages: ['CREATE_QUOTATION', 'POLICY_INFO', 'DECLARATION', 'BUYER_INFO'],
        mainInsuredNameOrEmail: searchQuery,
      };
      break;
    case 'SUSPENDED':
      filterObject = {
        statuses: ['SUSPEND'],
        stages: ['CREATE_ORDER'],
      };
      break;
    case 'IN_PROCESS':
      filterObject = { statuses: ['PAYMENT_PENDING', 'PAYMENT_PROCESSING'] };
      break;
    case 'AWAITING_ISSUANCE':
      filterObject = {
        statuses: ['FULLY_PAID', 'PARTIALLY_PAID'],
        published: 0,
        readyToIssue: 0,
      };
      break;
    case 'DASHBOARD':
      filterObject = { stages: ['CREATE_ORDER'] };
      break;
    default:
      filterObject = {};
  }

  if (searchQuery && type != 'INCOMPLETE') {
    filterObject = {
      ...filterObject,
      ...searchQuery.includes('LP-')
        ? { orderHumanId: searchQuery }
        : type != 'DASHBOARD'
          ? { buyerNameOrEmail: searchQuery }
          : { buyerNameOrEmailOrPhone: searchQuery },
    };
  }
  return JSON.stringify(filterObject);
}

function isValidSession(response) {
  if (response.data && response.data.status === 401) {
    toast.error(response.data.errorMessage);
    window.handleLogout();
  }
};

export function* updateQuotation() {

  yield put(actions.updatingQuotation({ loading: true }));

  yield put(actions.errorUpdatingQuotation({
    errorObject: { message: QUOTATION_SERVICE_UNAVAILABLE },
  }));
}

export function* getAgentMonthlyData(action) {
  const { queryObject, token } = action.payload;

  yield put(actions.loadingAgentMonthlyData({ loading: true }));

  try {
    const monthlyData = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `bearer ${token}`,
      path: `/api/agents/overview/data/?${qs.stringify(queryObject)}`,
    });

    action.callback && action.callback(monthlyData);

    yield put(actions.loadedAgentMonthlyData({ monthlyData }));
  } catch (e) {
    console.log('Error: ', e);
    yield put(actions.errorLoadingAgentMonthlyData({ errorObject: e }));
  }
}

export function* getAgentLevel(action) {
  const { token } = action.payload;

  yield put(actions.loadingAgentLevel());

  try {
    const agentLevel = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: '/api/agents/level/',
    });

    if (agentLevel.data.statusCode) {
      yield put(actions.errorLoadingAgentLevel({ errorMesage: agentLevel.data.message }));
    } else {
      yield put(actions.loadedAgentLevel({ agentLevel }));
    }
  } catch (e) {
    yield put(actions.errorLoadingAgentLevel({ errorMesage: 'Terjadi Kesalahan' }));
  }
}

export function* agentDashboardSearch(action) {
  const { queryObject, token } = action.payload;

  yield put(actions.searchingAgentDashboard({ loading: true }));

  try {
    const monthlyData = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `bearer ${token}`,
      path: `/api/agents/overview/data/?${qs.stringify({
        filter: getFilterForList('DASHBOARD', queryObject.searchQuery),
        page: queryObject.page,
      })}`,
    });

    yield put(actions.agentDashboardSearchResult({ monthlyData }));
  } catch (e) {
    console.log('Error: ', e);
    // yield put(actions.errorLoadingAgentMonthlyData({ errorObject: e }));
  }
}

export function* updateSchedule(action) {
  const { token, schedule } = action.payload;

  yield put(actions.updatingSchedule());

  try {
    const response = yield call(NextServerAPI, {
      method: 'PUT',
      AuthorizationToken: `bearer ${token}`,
      path: '/api/orders/schedule/callback/',
      data: schedule,
    });

    yield put(actions.updatedSchedule(response));
  } catch (e) {
    console.log('Error: ', e);
  }
}

export function* getAgentQuotationPlanAndOrder(action) {
  yield put(actions.loadingAgentQuotationPlanAndOrder());

  yield put(actions.errorLoadingAgentQuotationPlanAndOrder({
    errorMessage: QUOTATION_SERVICE_UNAVAILABLE,
  }));
  action.callback && action.callback(null);
}

export function* getPerson(action) {
  yield put(actions.loadingPerson());

  action.callback && action.callback({ success: false });
  yield put(actions.errorLoadingPerson({ errorMessage: QUOTATION_SERVICE_UNAVAILABLE }));
}

export function* updatePerson(action) {
  yield put(actions.updatingPerson());

  const status = {
    isSuccess: false,
    errorMessage: '',
  };

  const errorMessage = QUOTATION_SERVICE_UNAVAILABLE;
  status.errorMessage = errorMessage;
  yield put(actions.errorUpdatingPerson({ errorMessage }));

  if (action.callback) {
    action.callback(status);
  }
}

export function* updateQuotations(action) {
  const { data } = action.payload;

  yield put(actions.updatingQuotations());

  yield put(actions.errorUpdatingQuotations({ errorMessage: QUOTATION_SERVICE_UNAVAILABLE }));
  action.callback && action.callback({ errorMessage: QUOTATION_SERVICE_UNAVAILABLE, data });
}

export function* getPersonalAccount() {
  yield put(actions.loadingPersonalAccount());

  yield put(actions.errorLoadingPersonalAccount({ errorMessage: QUOTATION_SERVICE_UNAVAILABLE }));
}

export function* updatePolicyMember(action) {
  const { member } = action.payload;

  yield put(actions.updatingPolicyMember());

  const errorMessage = QUOTATION_SERVICE_UNAVAILABLE;
  yield put(actions.errorUpdatingPolicyMember({ errorMessage }));
  action.callback && action.callback({ errorMessage, member });
}

export function* updateDeclaration(action) {
  const { declaration } = action.payload;

  yield put(actions.updatingDeclaration());

  const errorMessage = QUOTATION_SERVICE_UNAVAILABLE;
  yield put(actions.errorUpdatingDeclaration({ errorMessage }));
  action.callback && action.callback({ errorMessage, declaration });
}

export function* updateQuotationStatus(action) {
  const { status } = action.payload;

  yield put(actions.updatingQuotationStatus());

  const errorMessage = QUOTATION_SERVICE_UNAVAILABLE;
  yield put(actions.errorUpdatingQuotationStatus({ errorMessage, status }));
}

export function* updateRefundOrder(action) {
  const { token, payload } = action.payload;

  yield put(actions.updatingRefundOrder());

  try {
    yield call(NextServerAPI, {
      method: 'POST',
      AuthorizationToken: `bearer ${token}`,
      path: '/api/orders/payments/refund/',
      data: payload,
    });

    yield put(actions.updatedRefundOrder());
  } catch (e) {
    let errorMessage = 'Mohon coba beberapa saat lagi.';

    if (e.code === 404) {
      errorMessage = 'Order sudah di Refund.';
    }

    yield put(actions.errorUpdatingRefundOrder({ errorMessage }));
  }
}

export function* getLeadQuotationInfo() {
  yield put(actions.loadingLeadQuotationInfo({ loading: true }));

  yield put(actions.errorLoadingLeadQuotationInfo({ errorMessage: QUOTATION_SERVICE_UNAVAILABLE }));
}

export function* createLead(action) {
  const { token, data, isABTest = false } = action.payload;

  yield put(actions.creatingLead());

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'POST',
      path: '/api/leads/create-lead/',
      data,
    });

    if (response.data.statusCode === 400) {
      yield put(actions.errorCreatingLead({
        errorMessage: 'Maaf, Pelanggan sudah didaftarkan oleh agent Lifepal lainnya'
      }));
      toast.error('Maaf, Pelanggan sudah didaftarkan oleh agent Lifepal lainnya');
    } else if (response.data.status === 422) {
      yield put(actions.errorCreatingLead({
        errorMessage: 'Lead yang Anda tambahkan sudah ada di Lifepal'
      }));
      !isABTest && toast.error('Lead yang Anda tambahkan sudah ada di Lifepal');
    } else {
      yield put(actions.createdLead({ response }));
      action.callback && action.callback(response);
      !isABTest && toast.success('Leads Berhasil Ditambah');
    }
  } catch (e) {
    console.log(e);
  }
}

export function* getLeadList(action) {
  const { token } = action.payload;

  yield put(actions.loadingLeadList({ loading: true }));

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: '/api/leads/list/',
    });

    isValidSession(response);

    yield put(actions.loadedLeadList({ response }));
    action.callback && action.callback(true);
  } catch (e) {
    console.log(e);
  }
}

export function* updateQueueSchedule(action) {
  const { leadId, token, data } = action.payload;

  yield put(actions.updatingQueueSchedule());

  try {
    const response = yield call(NextServerAPI, {
      method: action.payload.method || 'PATCH',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/leads/schedule/${leadId}/`,
      data,
    });

    toast.success('Pelanggan telah dijadwal ulang untuk dihubungi kembali');

    action.callback && action.callback();

    if (!action.payload.method) {
      yield call(getLeadByLeadID, { payload: { token, leadId } });
    }

    yield put(actions.updatedQueueSchedule({ response, shouldSplice: action.payload.shouldSplice }));
  } catch (e) {
    const errorMessage = 'Terjadi kesalahan, silahkan coba berberapa saat lagi.';
    toast.error(errorMessage);
    action.callback && action.callback();
    yield put(actions.errorUpdatingQueueSchedule());
  }
}

export function* rejectLead(action) {
  const { queryId, token, data, isUpdatingNote } = action.payload;

  yield put(actions.rejectingLead());

  try {
    yield call(NextServerAPI, {
      method: 'PUT',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/leads/reject/${queryId}/`,
      data,
    });

    yield call(getLeadByLeadID, { payload: { token, leadId: queryId } });

    if (isUpdatingNote) {
      toast.success('Catatan berhasil ditambahkan');
    } else {
      toast.success('Pelanggan telah dihapus');
    }

    yield put(actions.rejectedLead());
  } catch (e) {
    const errorMessage = 'Terjadi kesalahan, silahkan coba berberapa saat lagi.';
    toast.error(errorMessage);

    yield put(actions.errorRejectingLead({ errorMessage }));
  }
}

export function* getBankAccountDetail() {
  yield put(actions.loadingBankAccountDetail());

  yield put(actions.errorLoadingBankAccountDetail({ errorMessage: QUOTATION_SERVICE_UNAVAILABLE }));
}

export function* updatePersonalAccount() {
  yield put(actions.updatingPersonalAccount());

  const errorMessage = QUOTATION_SERVICE_UNAVAILABLE;
  toast.error('Penambahan akun bank gagal. Silahkan coba lagi');
  yield put(actions.errorUpdatingPersonalAccount({ errorMessage }));
}

export function* getLeadSummaryList(action) {
  const { token, query } = action.payload;
  yield put(actions.loadingLeadSummaryList({ loading: true }));

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/agents/${query.page}/${query.search}/`,
    });

    yield put(actions.loadedLeadSummaryList({ response }));
  } catch (e) {
    const errorMessage = 'Error Loading Lead Summary List';
    toast.error(errorMessage);
  }
}

export function* getTransactionSummary(action) {
  const { token } = action.payload;

  const leadOwner = AGENT_CONSTANTS.getAgentByToken(token).leadOwner;
  let startDate;
  if (leadOwner === 'organization') {
    startDate = daysjs().startOf('month');
  }

  yield put(actions.loadingTransactionSummary());

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/leads/transaction-summary/?startDate${startDate}`,
    });

    yield put(actions.loadedTransactionSummary({ response }));
  } catch (e) {
    console.log(e);
    yield put(actions.errorLoadingTransactionSummary());
  }
}

export function* getAgentPerformance(action) {
  const { token, me } = action.payload;

  const leadOwner = AGENT_CONSTANTS.getAgentByToken(token).leadOwner;
  const query = {
    agentId: me.user_id,
    ...leadOwner === 'organization' ? {
      startDate: daysjs().startOf('month').format('YYYY-MM-DD'),
      endDate: daysjs().endOf('month').format('YYYY-MM-DD'),
    } : {},
  };

  yield put(actions.loadingAgentPerformance());

  try {
    const response = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: '',
      path: `/api/orders/agent-performance/?${qs.stringify(query)}`,
    });

    yield put(actions.loadedAgentPerformance({ response }));
  } catch (e) {
    console.log(e);
    yield put(actions.errorLoadingAgentPerformance());
  }
}

export function* getAgentDetail(action) {
  const { token, agentId } = action.payload;

  yield put(actions.loadingAgentDetail());

  try {
    const response = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/agents/detail/${agentId}/`,
    });

    yield put(actions.loadedAgentDetail({ response }));
  } catch (e) {
    console.log(e);
    yield put(actions.errorLoadingAgentDetail());
  }
}

export function* getUserDetails(action) {
  const { data, token } = action.payload;

  yield put(actions.loadingUserDetails());

  try {
    const response = yield call(NextServerAPI, {
      method: 'POST',
      AuthorizationToken: `Bearer ${token}`,
      path: '/api/user/user-by-id/',
      data
    });

    yield put(actions.loadedUserDetails({ response }));
  } catch (e) {
    yield put(actions.errorLoadingAgentData({ errorMesage: 'Error Loading User Details' }));
  }
}

export function* getAgentData(action) {
  const { token } = action.payload;

  yield put(actions.loadingAgentData());

  try {
    const agentData = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: '/api/agents/agent-data/',
    });

    isValidSession(agentData);

    if (agentData.data.statusCode) {
      yield put(actions.errorLoadingAgentData({ errorMesage: agentData.data.message }));
    } else {
      yield put(actions.loadedAgentData({ agentData }));
      action.callback && action.callback(agentData.data);
    }

  } catch (e) {
    yield put(actions.errorLoadingAgentData({ errorMesage: 'Error Loading Agent Data' }));
  }
}

export function* getAgentTeams(action) {
  const { token, agentId } = action.payload;

  yield put(actions.loadingAgentTeams());

  try {
    const agentTeams = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/agents/agent-teams/?agentId=${agentId}`,
    });

    if (agentTeams.data.statusCode) {
      yield put(actions.errorLoadingAgentTeams({ errorMesage: agentTeams.data.message }));
    } else {
      yield put(actions.loadedAgentTeams({ agentTeams }));
    }
  } catch (e) {
    yield put(actions.errorLoadingAgentTeams({ errorMesage: 'Error Loading Agent Teams' }));
  }
}

export function* createQueueEntry(action) {
  const { data } = action.payload;
  const gaId = tomiAI.getGaId();
  const landing_page = jsCookie.get('landing_page');
  const payload = data;

  if (gaId) {
    payload.utm_data = payload.utm_data || {};
    payload.utm_data.ga_id = gaId;
  }

  if (landing_page) {
    payload.lead_info_data = payload.lead_info_data || {};
    payload.lead_info_data.landing_page = landing_page;
  }

  yield put(actions.creatingQueueEntry());

  try {
    const response = yield call(NextServerAPI, {
      method: 'POST',
      path: '/api/leads/list/',
      data: payload,
    });

    yield put(actions.createdQueueEntry({ response }));
    action.callback && action.callback(response);
  } catch (e) {
    action.callback && action.callback();
    yield put(actions.errorCreatingQueueEntry({
      errorMessage: 'Error creating queue entry'
    }));
  }
}

export function* markAgentAvailability(action) {
  const { token, data } = action.payload;

  yield put(actions.markingAgentAvailability());

  try {
    const response = yield call(NextServerAPI, {
      method: 'PUT',
      AuthorizationToken: `Bearer ${token}`,
      path: '/api/agents/agent-availability/',
      data
    });

    yield put(actions.markedAgentAvailability({ response }));
  } catch (err) {
    yield put(actions.errorMarkingAgentAvailability());
  }
}

export function* initiateManualDial(action) {
  const { token, data } = action.payload;

  yield put(actions.initiatingManualDial({ lead: data.phoneNumber }));

  try {
    const response = yield call(NextServerAPI, {
      method: 'POST',
      AuthorizationToken: `Bearer ${token}`,
      path: '/api/leads/manual-dial/',
      data
    });

    yield put(actions.setManualDial({ isEnabled: response.data.manual_dial_status }));

    yield put(actions.initiatedManualDial({ response }));
  } catch (err) {
    yield put(actions.errorInitiatingManualDial());
  }
}

export function* createNotes(action) {
  const { token, data } = action.payload;

  yield put(actions.creatingNotes());

  try {
    const response = yield call(NextServerAPI, {
      method: 'POST',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/leads/notes/add/`,
      data,
    });

    toast.success('Catatan Telah Ditambah');

    yield put(actions.createdNotes({ response }));
  } catch (e) {
    const errorMessage = 'Something went wrong while creating notes!';
    toast.error(errorMessage);

    yield put(actions.errorCreatingNotes({ errorMessage }));
  }
}

export function* getNotesHistory(action) {
  const { leadId, token } = action.payload;

  yield put(actions.loadingNotesHistory());

  try {
    const response = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/leads/notes/${leadId}/`,
    });

    yield put(actions.loadedNotesHistory({ response }));
  } catch (e) {
    const errorMessage = 'Something went wrong while loading notes!';
    toast.error(errorMessage);

    yield put(actions.errorLoadingNotesHistory({ errorMessage }));
  }
}

export function* getAgentLeaderboard(action) {
  const { token, agentId } = action.payload;

  yield put(actions.loadingAgentLeaderboard());

  try {
    const response = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: '/api/agents/agent-ranking/',
    });

    yield put(actions.loadedAgentLeaderboard({ response, agentId }));
  } catch (e) {
    const errorMessage = 'Terjadi Kesalahan.';
    toast.error(errorMessage);

    yield put(actions.errorLoadingAgentLeaderboard({ errorMessage }));
  }
}

export function* getCallRecordingList(action) {
  const { token, agentId } = action.payload;

  yield put(actions.loadingCallRecordingList());

  try {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    currentDate.setHours(17, 0, 0, 0);

    const callRecordingList = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/agents/calls/${agentId}/${currentDate.toISOString()}/`
    });

    yield put(actions.loadedCallRecordingList({ callRecordingList }));
  } catch (e) {
    const errorMessage = 'Error Loading Call Recording';
    toast.error(errorMessage);

    yield put(actions.errorLoadingCallRecordingList({ errorMesage }));
  }
}

export function* getCallRecordingByNumber(action) {
  const { token, phoneNumber } = action.payload;

  yield put(actions.loadingCallRecordingByNumber());

  try {
    const recordingList = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/agents/calls/phone-number/${phoneNumber}/`
    });

    yield put(actions.loadedCallRecordingByNumber({ recordingList }));
  } catch (e) {
    const errorMessage = 'Error Loading Call Recording';
    toast.error(errorMessage);

    yield put(actions.errorLoadingCallRecordingByNumber({ errorMesage }));
  }
}

export function* getAgentStatusList(action) {
  const { token } = action.payload;

  yield put(actions.loadingAgentStatus());

  try {
    const agentStatusList = yield call(NextServerAPI, {
      method: 'GET',
      AuthorizationToken: `Bearer ${token}`,
      path: `/api/agents/status/`,
    });

    yield put(actions.loadedAgentStatus({ agentStatusList }));
  } catch (e) {
    const errorMessage = 'Something went wrong while loading agents status!';
    toast.error(errorMessage);

    yield put(actions.errorLoadingAgentStatus({ errorMessage }));
  }
}

export function* getLeadListByAgentID(action) {
  const { token, agentId } = action.payload;

  yield put(actions.loadingLeadListByAgentid({ loading: true }));

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/agents/${agentId}/`,
    });

    action.callback && action.callback(response);

    yield put(actions.loadedLeadListByAgentid({ response }));
  } catch (e) {
    console.log(e);
  }
}

export function* getCallLogsByAgent(action) {
  const { token, agentId, page } = action.payload;

  yield put(actions.loadingCallLogsByAgent());

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/agents/call-logs/agents/${agentId}?page=${page}`,
    });

    action.callback && action.callback(response);
    yield put(actions.loadedCallLogsByAgent({ response }));
  } catch (e) {
    console.log(e);
  }
}

export function* getCallLogsByLead(action) {
  const { token, leadId, page } = action.payload;

  yield put(actions.loadingCallLogsByLead());

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/agents/call-logs/leads/${leadId}?page=${page}`,
    });

    action.callback && action.callback(response);
    yield put(actions.loadedCallLogsByLead({ response }));
  } catch (e) {
    console.log(e);
  }
}

export function* getLeadByLeadID(action) {
  const { token, leadId } = action.payload;

  yield put(actions.loadingLeadByLeadid({ loading: true }));

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/leads/${leadId}/`,
    });

    action.callback && action.callback(response);

    yield put(actions.loadedLeadByLeadid({ response }));
  } catch (e) {
    console.log(e);
  }
}

export function* sendMessage(action) {
  const { token, data } = action.payload;

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'POST',
      path: `/api/agents/chat/send-message/`,
      data,
    });

    action.callback && action.callback(response);
  } catch (e) {
    console.log(e);
  }
}

export function* getMessageList(action) {
  const { token, leadId, pageNumber } = action.payload;

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/leads/message/${leadId}/${pageNumber || 1}/`,
    });

    yield put(actions.loadedMessageList({ response,leadId, pageNumber }));

    action.callback && action.callback(response);
  } catch (e) {
    console.log(e);
  }
}

export function* sendTemplate(action) {
  const { token, data } = action.payload;

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'POST',
      path: `/api/leads/message/send-template/`,
      data,
    });

    action.callback && action.callback(response);
    toast.success('template terkirim');
    yield put(actions.sentTemplate({ response }));

  } catch (e) {
    action.callback && action.callback();
    console.log(e);
  }
}

export function* getAgentChatHistory(action) {
  const { token, agentId } = action.payload;

  yield put(actions.loadingAgentChatHistory({ laoding: true }));

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'GET',
      path: `/api/agents/chat/${agentId}/`,
    });

    action.callback && action.callback(response);

    yield put(actions.loadedAgentChatHistory({ response }));
  } catch (e) {
    console.log(e);
  }
}

export function* sendProposal(action) {
  const { token, data } = action.payload;

  yield put(actions.sendingProposal({ laoding: true }));

  try {
    const response = yield call(NextServerAPI, {
      AuthorizationToken: `Bearer ${token}`,
      method: 'POST',
      path: `/api/agents/chat/send-proposal/`,
      data,
    });

    yield put(actions.sentProposal({ laoding: false }));

    action.callback && action.callback(response);
  } catch (e) {
    console.log(e);
  }
}

export default [
  [actionTypes.UPDATE_QUOTATION, updateQuotation],
  [actionTypes.GET_AGENT_QUOTATION_PLAN_AND_ORDER, getAgentQuotationPlanAndOrder],
  [actionTypes.UPDATE_PERSON, updatePerson],
  [actionTypes.UPDATE_POLICY_MEMBER, updatePolicyMember],
  [actionTypes.UPDATE_DECLARATION, updateDeclaration],
  [actionTypes.UPDATE_QUOTATION_STATUS, updateQuotationStatus],
  [actionTypes.GET_AGENT_MONTHLY_DATA, getAgentMonthlyData],
  [actionTypes.AGENT_DASHBOARD_SEARCH, agentDashboardSearch],
  [actionTypes.UPDATE_SCHEDULE, updateSchedule],
  [actionTypes.UPDATE_REFUND_ORDER, updateRefundOrder],
  [actionTypes.GET_PERSON, getPerson],
  [actionTypes.UPDATE_PERSONAL_ACCOUNT, updatePersonalAccount],
  [actionTypes.GET_PERSONAL_ACCOUNT, getPersonalAccount],
  [actionTypes.GET_LEAD_QUOTATION_INFO, getLeadQuotationInfo],
  [actionTypes.GET_LEAD_LIST, getLeadList],
  [actionTypes.REJECT_LEAD, rejectLead],
  [actionTypes.UPDATE_QUEUE_SCHEDULE, updateQueueSchedule],
  [actionTypes.GET_BANK_ACCOUNT_DETAIL, getBankAccountDetail],
  [actionTypes.CREATE_LEAD, createLead],
  [actionTypes.GET_AGENT_LEVEL, getAgentLevel],
  [actionTypes.UPDATE_QUOTATIONS, updateQuotations],
  [actionTypes.GET_LEAD_SUMMARY_LIST, getLeadSummaryList],
  [actionTypes.GET_TRANSACTION_SUMMARY, getTransactionSummary],
  [actionTypes.GET_AGENT_PERFORMANCE, getAgentPerformance],
  [actionTypes.GET_AGENT_DETAIL, getAgentDetail],
  [actionTypes.GET_AGENT_DATA, getAgentData],
  [actionTypes.GET_AGENT_TEAMS, getAgentTeams],
  [actionTypes.GET_USER_DETAILS, getUserDetails],
  [actionTypes.CREATE_QUEUE_ENTRY, createQueueEntry],
  [actionTypes.MARK_AGENT_AVAILABILITY, markAgentAvailability],
  [actionTypes.INITIATE_MANUAL_DIAL, initiateManualDial],
  [actionTypes.CREATE_NOTES, createNotes],
  [actionTypes.GET_NOTES_HISTORY, getNotesHistory],
  [actionTypes.GET_AGENT_LEADERBOARD, getAgentLeaderboard],
  [actionTypes.GET_CALL_RECORDING_LIST, getCallRecordingList],
  [actionTypes.GET_CALL_RECORDING_BY_NUMBER, getCallRecordingByNumber], // 11
  [actionTypes.GET_AGENT_STATUS, getAgentStatusList],
  [actionTypes.GET_LEAD_LIST_BY_AGENTID, getLeadListByAgentID],
  [actionTypes.GET_CALL_LOGS_BY_AGENT, getCallLogsByAgent],
  [actionTypes.GET_CALL_LOGS_BY_LEAD, getCallLogsByLead],
  [actionTypes.GET_LEAD_BY_LEADID, getLeadByLeadID],
  [actionTypes.SEND_MESSAGE, sendMessage],
  [actionTypes.GET_MESSAGE_LIST, getMessageList],
  [actionTypes.SEND_TEMPLATE, sendTemplate],
  [actionTypes.GET_AGENT_CHAT_HISTORY, getAgentChatHistory],
  [actionTypes.SEND_PROPOSAL, sendProposal],
];
